import React from 'react';
import styled from 'styled-components';
import useHandleSwatchCart from '../../../../../../hooks/useHandleSwatchCart';
import useHandleWaitlistProduct from '../../../../../../hooks/useHandleWaitlistProduct';
import { Button } from '../../../../../../styles/theme/default/buttons';
import { getPrice } from '../../../../../../utils/helper';

const Wrapper = styled.div`
  margin-top: 16px;
  button {
    height: 48px;
    border: ${({theme}) => theme.old ? '1px solid #6c6c6c' : 'none'};
    width: fit-content;
    padding: 0 20px;
    min-width: 130px;
  }
`;

const formatData = fabric => {
  return {
    ...fabric,
    swatch: {
      ...fabric.swatch,
      fabric: { ...fabric }
    }
  };
};

function AddSwatchToCartButton({ productData, className }) {
  const [handleCart, { loading, checkIfIsInCart }] = useHandleSwatchCart();
  const [
    handleClick,
    checkIfOnWaitlist,
    { loading: loadingWaitlist }
  ] = useHandleWaitlistProduct();

  const swatch = formatData(productData.fabric)?.swatch;

  const isPurchasable = productData.fabric.swatch.is_purchasable;

  const isNotBedding = productData?.frame?.primarySubcategory?.category_id != 50;

  const loadingSpinner = (
    <div
      style={{
        borderWidth: '2px',
        width: 15,
        height: 15
      }}
      className="spinner-border text-dark"
      role="status"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );

  return (
    <Wrapper className={className ? className : ''}>
      {isPurchasable ? (
        <Button
          disabled={loading}
          onClick={() => {
            handleCart(swatch, 10);
          }}
        >
          {loading
            ? loadingSpinner
            : checkIfIsInCart(swatch.id)
            ? 'Remove from Cart'
            : `Add $${getPrice(swatch.price)} Swatch`}
        </Button>
      ) : isNotBedding ? (
        <Button
        onClick={() => handleClick(swatch.id)}
        disabled={loadingWaitlist}
      >
        {loadingWaitlist
          ? loadingSpinner
          : checkIfOnWaitlist(swatch.id)
          ? 'Remove from Waitlist'
          : 'Add to Waitlist'}
      </Button>
      ) : null}
    </Wrapper>
  );
}

export default AddSwatchToCartButton;
